import { computed, ref, reactive } from 'vue'
import {
    getPackagesList,
    getPackage,
    getPackageById,
    GetPackageResponse,
    addSinglePackage,
    updateSinglePackage,
    activateSinglePackage,
    deactivateSinglePackage,
    deleteSinglePackage,
    GetPackagesListResponse,
    AddPackageRequest,
    UpdatePackageRequest
} from './api'
import { Package } from './types'

export * from './types'

export const procountorProduct = [
    { value: 9900, label: 'Koulutuspaketti -internal (9900)' },
    { value: 1540, label: 'O365 (1540)' },
    { value: 1090, label: 'Esimies (1090)' },
    { value: 1430, label: 'HR (1430)' }
]

export const packageStatus = ['active', 'inactive']

const packages = ref<GetPackagesListResponse>([])
const singlePackage = reactive<GetPackageResponse>({
    id: '',
    description: '',
    name: '',
    code: '',
    status: '',
    createdAt: '',
    updatedAt: ''
})

const getPackages = () => {
    if (packagesBeingFetched.value) {
        return
    }
    packagesBeingFetched.value = true
    getPackagesList().then((packagesList) => {
        packagesFetched.value = true
        packagesBeingFetched.value = false
        packages.value = packagesList
    })
}

const withPackagesListUpdate = async <T = void>(callback: () => T): Promise<T> => {
    const callbackResult = await callback()
    await getPackages()
    return callbackResult
}

const getPackageNameById = (id: string): string => {
    const foundPackage = packages.value.find(p => p.id === id)
    if (!foundPackage) return ''
    else return foundPackage.name
}

const addPackage = (payload: AddPackageRequest) =>
    withPackagesListUpdate(
        () => addSinglePackage(payload)
    )

const updatePackage = (id: string, payload: UpdatePackageRequest) =>
    withPackagesListUpdate(
        () => updateSinglePackage(id, payload)
    )

const activatePackage = (code: string) =>
    withPackagesListUpdate(
        () => activateSinglePackage(code)
    )

const deactivatePackage = (code: string) =>
    withPackagesListUpdate(
        () => deactivateSinglePackage(code)
    )

const deletePackage = (id: string) =>
    withPackagesListUpdate(
        () => deleteSinglePackage(id)
    )

const packagesFetched = ref(false)
const packagesBeingFetched = ref(false)

export function usePackageModule () {
    return {
        getPackages,
        packages: computed(() => {
            if (!packagesFetched.value) {
                getPackages()
            }
            return packages.value
        }),
        packagesById: computed(() => {
            if (!packagesFetched.value) {
                getPackages()
            }
            return packages.value.reduce(
                (map, packageItem) => {
                    map.set(packageItem.id, packageItem)
                    return map
                },
                new Map<string, Package>()
            )
        }),
        packagesOptions: computed(() => {
            return packages.value.map((packageItem: Package) => {
                return {
                    value: packageItem.code,
                    label: packageItem.name
                }
            })
        }),
        getPackage,
        getPackageById,
        singlePackage,
        addPackage,
        updatePackage,
        activatePackage,
        deactivatePackage,
        deletePackage,
        packageStatus,
        getPackageNameById
    }
}
